module.exports = __webpack_public_path__ + "static/media/up-to-date.8b6b1aaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/up-to-date.svg
// module id = 792
// module chunks = 0